module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-content"
  }, [_c('div', {
    staticClass: "app-content-body dashboard"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [_c('div', {
    staticClass: "bg-light lter b-b-xs wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                Dashboard")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                  LOG DEP Mobilidade Urbana\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "text-right text-left-xs"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_vm._v("\n            Seja bem vindo à intranet. Estamos trabalhando para levar o máximo de informação aos colaboradores. "), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n            Nosso dashboard está temporariamente desativado.\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebfef4e2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard/components/Main.vue
// module id = 1907
// module chunks = 17